import type { FeatureMiddleware } from '@cast/api-client';

import { handleOpDemoInterceptor } from '../utils';

export const auditLog: FeatureMiddleware<'auditLog'> = {
  getAuditLog: async (controls) => {
    return handleOpDemoInterceptor(controls);
  },
};
